import { get } from "lodash";

const AGENT_KEY = "experts_program.campaign.active_expert";

const parseGqlDataByKey = ({ data, ...rest }, key = AGENT_KEY) => ({
  ...get(data, key),
  data,
  ...rest
});

export default parseGqlDataByKey;
